import React from "react";
import { useParams } from "react-router-dom";
import MobileFormViewManager from "../../components/common/mobile/MobileFormViewManager";
import TinyMCEpreview from "../../components/const/TinyMCEpreview";

export default function Progress_view() {
  const { id: projectId, dns } = useParams();

  return (
    <MobileFormViewManager
      params={{
        project: projectId,
        dns,
        module: "const",
        doc_type: "weekly",
      }}
      doc_name="주/월간 보고서"
    >
      <ProgressBody />
    </MobileFormViewManager>
  );
}

function ProgressBody({ meta }) {
  if (!meta) return null;

  return (
    <div className="mt-4">
      <section className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
        <h3 className="text-lg font-bold text-gray-900 mb-4">
          상세 내용
        </h3>
        <div className="min-h-[150px]">
          {meta.template ? (
            <TinyMCEpreview html={meta.template} />
          ) : (
            <div className="text-gray-400 py-4">내용이 없습니다.</div>
          )}
        </div>
      </section>
    </div>
  );
}